import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Button } from '@mui/material';
import { loginRequest } from '../authConfig';

/*
 * Azure AD access restriction for the AI Scoring frontend (SCINFRA-686).
 * Shows a Login button and only starts the Azure AD redirect on click -
 * mirroring sc-internal-tool's TheHeader.vue (signIn() is only called from
 * the Login button's onClick, never automatically on mount). Actual
 * enforcement is server-side (main.py validates the ID token independently);
 * this only gates what the SPA shows before that.
 */
interface AuthGateProps {
  children: React.ReactNode;
}

const AuthGate: React.FC<AuthGateProps> = ({ children }) => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  if (!isAuthenticated) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}>
        <h2>AI Scoring Evaluation Service</h2>
        <Button variant="contained" onClick={handleLogin}>
          Login
        </Button>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthGate;
